import React, {useEffect} from 'react';

import {BackArrowBlack, CloseIconGray, SearchIconBlack} from '../../../styles/icons';
import Config from '../../../utils/Configuration';
import {pagePath} from '../../../RouteConfig';
import Utility from '../../../utils/Helper';

export default function SearchBar({
    intl,
    searchString,
    updateSearchString,
    getSearchResults,
    setShowSearch,
    screenName,
    navigate
}) {
    useEffect(() => {
        document.getElementById('searchInputBar') && document.getElementById('searchInputBar').focus();
    }, []);

    const processSearchResult = () => {
        setShowSearch(false);
        if (screenName !== Config.pageName.solrSR) {
            Utility.navigateTo(pagePath.solrSearchResultUrl, navigate);
        } else {
            getSearchResults(searchString);
        }
    };

    return (
        <div id='searchHeader'>
            <div>
                <form
                    id='searchBar'
                    className='container searchBar px-3 px-md-0 d-flex align-items-center justify-content-between'
                    action=''
                    onSubmit={processSearchResult}
                >
                    <BackArrowBlack onClick={() => setShowSearch(false)} />
                    <input
                        id='searchInputBar'
                        type='search'
                        value={searchString}
                        className='fs-14 maxis-semiBold text-gunmetal pl-1'
                        spellCheck={false}
                        autoComplete='off'
                        placeholder={intl.messages.searchLabel}
                        onChange={(e) => {
                            updateSearchString(e.target.value);
                        }}
                    />
                    {searchString && (
                        <span className='close-icon cursor-pointer me-2' onClick={() => updateSearchString('')}>
                            <CloseIconGray />
                        </span>
                    )}
                    <span className='pl-1 cursor-pointer' onClick={processSearchResult}>
                        <SearchIconBlack />
                    </span>
                </form>
            </div>
        </div>
    );
}
